import microApp from '@frontend/micro-app'
import { initDingH5RemoteDebug } from 'dingtalk-h5-remote-debug'
import React from 'react'
import ReactDOM from 'react-dom'
import 'text-security/text-security.css'
import App from './App'
import './index.css'
const origin = window.location.origin
initDingH5RemoteDebug()
microApp.start({
  'disable-patch-request': true, // 关闭对子应用请求的拦截
  'router-mode': 'native',
  preFetchApps: [
    { name: 'navigate', url: `${origin}/app/navigate` },
    { name: 'workbench', url: `${origin}/app/workbench` },
  ],
})

const container = document.getElementById('root')

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  container,
)
